import map from 'lodash/map';
import MuiSelect from '@mui/material/Select';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import MenuItem from '@mui/material/MenuItem';
import HTMLFragment from 'components/HTMLFragment';

export default class SelectField extends PureComponent {
  static propTypes = {
    ...MuiSelect.propTypes,
    options: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    showEmpty: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  };
  static defaultProps = {
    placeholder: 'Select one',
    showEmpty: true,
  };
  focus = () => { };
  // TODO: Rendering this in Modal causing problem for option selection(Can't select).
  render() {
    const {
      options,
      placeholder,
      showEmpty,
      onChange,
      ...props
    } = this.props;
    return (
      <MuiSelect
        {...props}
        displayEmpty={showEmpty}
        variant='standard'
        onChange={(event, i) => onChange && onChange(event, i, event.target.value)}
      >
        {showEmpty && (
          <MenuItem
            value=''
          >
            {placeholder}
          </MenuItem>
        )}
        {map(options, (val, key, idx) => (
          <MenuItem
            key={key || idx}
            value={key}
          >
            <HTMLFragment>
              {val}
            </HTMLFragment>
          </MenuItem>
        ))}
      </MuiSelect>
    );
  }
}
